import React from "react";
import Title from "../atoms/typography/Title";
import Subtitle from "../atoms/typography/Subtitle";
import SecondarySubtitle from "../atoms/typography/SecondarySubtitle";

const Titles = ({ content, children }) => (
  <>
    {content.title && <Title>{content.title}</Title>}
    {children}
    {content.subtitle && <Subtitle>{content.subtitle}</Subtitle>}
    {content.secondarySubtitle && (
      <SecondarySubtitle>{content.secondarySubtitle}</SecondarySubtitle>
    )}
  </>
);

export default Titles;
